import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/splice";
import _sliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/slice";
import _sortInstanceProperty from "@babel/runtime-corejs3/core-js/instance/sort";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js/instance/index-of";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ProfileAvatar from "@Shared/components/general/profile-avatar";
import ReferrerTrophy from "./referrer-trophy.vue";
import { capitalize, cloneDeep } from "lodash";
import { REFERRAL_SOURCE_ENABLED } from "@Broker/@Modules/main/store/account/account-getters";
import { mapGetters } from "vuex";
import { Event } from "@alexrafael10/vue-tables-2";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ReferrersTable",
  components: {
    ProfileAvatar,
    ReferrerTrophy
  },
  props: {
    referrers: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      deafult: false
    }
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("AccountStore", [REFERRAL_SOURCE_ENABLED])), {}, {
    tableColumns() {
      const columns = ["fullName", "email", "phoneNumber", "referralCode", "type", "value", "actionbuttons"];
      if (!this.REFERRAL_SOURCE_ENABLED) {
        _spliceInstanceProperty(columns).call(columns, 3, 1);
      }
      return columns;
    },
    topValues() {
      var _context, _context2;
      const combinedValues = _sliceInstanceProperty(_context = _sortInstanceProperty(_context2 = cloneDeep(this.referrers)).call(_context2, (a, b) => this.getCombined(b) - this.getCombined(a))).call(_context, 0, 3);
      return _reduceInstanceProperty(combinedValues).call(combinedValues, (acc, {
        id
      }, index) => {
        acc[id] = index;
        return acc;
      }, {});
    },
    options() {
      return {
        uniqueKey: "id",
        filterable: false,
        sortable: ["fullName", "email", "type", "referralCode", "value"],
        sortingAlgorithm: data => data,
        sortIcon: {
          base: "fa",
          up: "fa-sort-up",
          down: "fa-sort-down",
          is: "fa-sort"
        },
        headings: {
          fullName: this.$t("tables.columns.fullName"),
          email: this.$t("tables.columns.email"),
          phoneNumber: this.$t("account.phoneNumber"),
          referralCode: this.$t("referrers.referralCode"),
          type: capitalize(this.$tc("global.words.type", 1)),
          value: this.$t("referrers.messages.cValue"),
          actionbuttons: "nodisplay"
        },
        perPage: 999999,
        tabbable: false,
        skin: "table table-hover",
        customFilters: [{
          name: "fullName",
          callback: (row, query) => {
            var _context3;
            const searchString = `${row.givenName} ${row.familyName} ${row.email} ${row.type}`;
            return _indexOfInstanceProperty(_context3 = searchString.toLowerCase()).call(_context3, query.toLowerCase()) >= 0;
          }
        }],
        texts: {
          noResults: this.$t("tables.messages.emptyReferrers")
        }
      };
    }
  }),
  mounted() {
    Event.$on("vue-tables.sorted", ({
      column,
      ascending
    }) => {
      this.$emit("sort", {
        orderBy: column,
        orderType: ascending ? "ASC" : "DESC"
      });
    });
  },
  methods: {
    referrerDetailsLink({
      id
    }) {
      return {
        name: "referrer-details",
        params: {
          referrerId: id
        }
      };
    },
    getCombined({
      active,
      inactive
    }) {
      return _parseInt(active) + _parseInt(inactive);
    }
  }
});